/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'scale': {
    width: 52,
    height: 52,
    viewBox: '0 0 52 52',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M14 24.375C14 18.645 18.645 14 24.375 14S34.75 18.645 34.75 24.375 30.105 34.75 24.375 34.75 14 30.105 14 24.375zM24.375 12C17.541 12 12 17.54 12 24.375c0 6.834 5.54 12.375 12.375 12.375 6.834 0 12.375-5.54 12.375-12.375C36.75 17.541 31.21 12 24.375 12zm10.457 21.418a1 1 0 00-1.414 1.414l4.875 4.875a1 1 0 001.414-1.414l-4.875-4.875z" _fill="#15386C"/><path pid="1" d="M24.4 18.8V30m-5.6-5.6H30" _stroke="#15386C" stroke-width="2"/>'
  }
})
